"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationEvent = exports.CompletedAction = void 0;
exports.postNotification = postNotification;
var NotificationEvent = exports.NotificationEvent = {
  LOADER_LOADING: 'lead-gen.loader.loading',
  LOADER_ERROR: 'lead-gen.loader.error',
  MODAL_LOADED: 'lead-gen.modal.loaded',
  EMBED_LOADED: 'lead-gen.embed.loaded',
  FORM_COMPLETED: 'lead-gen.form.completed',
  APPOINTMENT_SCHEDULED: 'lead-gen.appointment.scheduled',
  FLOW_COMPLETED: 'lead-gen.flow.completed'
};
var CompletedAction = exports.CompletedAction = {
  CALL_ME: 'call-me',
  SCHEDULE_CALL: 'schedule-a-call'
};
function postNotification(event) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.postMessage({
    event: event,
    payload: payload
  }, window.origin);
}